import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { CrossSellLightBoxActions } from '../constants/cross_sell_light_box/cross_sell_light_box_actions';

class CrossSellLightBoxStoreClass extends ReduceStore {
    getInitialState() {
        return {
            visible: false,
            expanded: false,
            invalid: false,
            invalidMessage: '',
            obj: null,
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.CROSS_SELL_LIGHTBOX_ACTION) {
            switch (action.type) {
                case CrossSellLightBoxActions.SHOW:
                    if (!state.visible) {
                        state.visible = true;
                        state.invalid = false;
                        state.invalidMessage = '';
                        state.obj = action.payload;
                        this.__emitChange();
                    }

                    break;

                case CrossSellLightBoxActions.HIDE:
                    if (state.visible) {
                        state.visible = false;
                        state.invalid = false;
                        state.invalidMessage = '';
                        state.obj = null;
                        this.__emitChange();
                    }

                    break;

                case CrossSellLightBoxActions.EXPAND:
                    if (!state.expanded) {
                        state.expanded = true;
                        this.__emitChange();
                    }

                    break;

                case CrossSellLightBoxActions.CROSS_SELL_INVALID_ACTION:
                    if (!state.invalid) {
                        state.invalid = true;
                        state.invalidMessage = action.payload;
                        this.__emitChange();
                    }
                    break;
            }
        }

        return state;
    }
}

const CrossSellLightBoxStore = new CrossSellLightBoxStoreClass(Dispatcher);
export { CrossSellLightBoxStore };
